export default "__VITE_ASSET__eZfiCuGT__"